export enum roles {
    site_admin = "site-admin", // Access to site
    site_admin_customization = "site-admin-customization", // Access to settings page for customization (logo, banner)
    site_admin_theme = "site-admin-theme", // Access to css variables on top of admin_customization
    site_admin_routes = "site-admin-routes", // Access to routes administration of the site
    site_admin_users = "site-admin-users", // Access to users administration of the site
    site_deploy_site = "site-deploy-site", // Access to deploy page
    site_deploy_customization = "site-deploy-customization" // Access to customization deployment
}